import styled, { css } from 'styled-components';
import { borderColors, primary } from '../../theme';
import { IThemeProps, themeTypes } from '../../interfaces';

export const GuidesGrid = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const GuideCard = styled.article<IThemeProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  width: 320px;
  min-height: 230px;
  padding: 26px 24px 22px;
  border-radius: 5px;
  ${props => css`
    border: 1px solid ${borderColors[props.theme as themeTypes]};
    background: ${primary[props.theme as themeTypes]};
  `}

  > div:first-child {
    display: flex;
    flex: 1;
    flex-direction: column;
  }
`;

export const GuideTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
`;

export const GuideDescription = styled.p`
  display: flex;
  flex: 1;
  align-items: center;
  margin: 18px 0 0;
  text-align: center;
  line-height: 1.45;
`;
